/* eslint-disable react/state-in-constructor */
import * as React from 'react';
import * as Sentry from '@sentry/browser';
import ErrorComponent from './ErrorComponent';

import './_errorBoundary.scss';

type Props = {
    children: React.ReactNode;
};

type State = {
    hasError: boolean;
};

export default class ErrorBoundary extends React.Component<Props, State> {
    state: State = {
        hasError: false,
    };

    componentDidCatch(error: Error, info: { componentStack: string }) {
        console.error(error);
        console.error(info.componentStack);
        Sentry.withScope((scope) => {
            scope.setExtras(info);
            Sentry.captureException(error);
        });
        this.setState({ hasError: true });
    }

    render(): React.ReactNode {
        if (this.state.hasError) {
            return <ErrorComponent />;
        }
        return this.props.children;
    }
}
